var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xEB\xA7\x90\xED\x92\x8D\xEC\x84\xA0",
    d: "M19.7155 0H12.1392C5.48874 0 0.0946739 5.49233 0.0946739 12.264V14.0963C0.0946739 16.9724 1.07241 19.6175 2.70196 21.7096L0.0379938 29.1786C-0.155663 29.7173 0.430031 30.2078 0.911813 29.9096L7.92126 25.586C9.23435 26.0862 10.6561 26.3603 12.1439 26.3603H19.7202C26.3706 26.3603 31.7647 20.868 31.7647 14.0963V12.264C31.7647 5.49233 26.3706 0 19.7202 0H19.7155Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 15",
    cx: 9.70611,
    cy: 13.2353,
    r: 1.76471,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 16",
    cx: 15.8824,
    cy: 13.2353,
    r: 1.76471,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 17",
    cx: 22.0587,
    cy: 13.2353,
    r: 1.76471,
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMobile);
export default __webpack_public_path__ + "static/media/chat_mobile.35c1cb46fc5d4018f888e7af33aeca6b.svg";
export { ForwardRef as ReactComponent };